<svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M1.05469 9.03125C0.828125 9.25781 0.820312 9.64844 1.05469 9.875C1.28906 10.1094 1.67188 10.1016 1.89844 9.875L5.75781 6.02344L9.60938 9.875C9.83594 10.1016 10.2188 10.1094 10.4531 9.875C10.6875 9.64844 10.6797 9.25781 10.4531 9.03125L6.60156 5.17969L10.4531 1.32812C10.6797 1.10156 10.6875 0.710938 10.4531 0.484375C10.2188 0.25 9.83594 0.25 9.60938 0.484375L5.75781 4.33594L1.89844 0.484375C1.67188 0.25 1.28906 0.25 1.05469 0.484375C0.820312 0.710938 0.828125 1.10156 1.05469 1.32812L4.90625 5.17969L1.05469 9.03125Z"
        fill="#00897B"
        class="fill-brand"
    />
</svg>
